import { Button } from '@web-app/components/ui/Button/button';

export function MedicareBridgeLoadError({
  onRetry,
}: {
  onRetry: () => void;
}) {
  return (
    <div
      className="flex flex-col items-start gap-2"
      data-testid="medicare-bridge-load-error"
    >
      <p role="alert" className="text-sm text-destructive">
        Could not load Medicare Bridge status. Try again.
      </p>
      <Button type="button" variant="outline" size="xs" onClick={onRetry}>
        Retry
      </Button>
    </div>
  );
}
